import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import LinearGradient from "react-native-linear-gradient";
import Text from "@components/AppText";
import colors from "@constants/color";
import BackArrow from "@assets/svg/BackArrow";

import t from "@constants/localization";

const PATH = "screens/AddBankDetails/Header";

const WithdrawMoneyHeader = ({ navigation, params }) => {
  return (
    <View
      style={[
        styles.beLikeRow,
        styles.headerContainer,
        { justifyContent: "space-between" },
      ]}
    >
      <View style={styles.beLikeRow}>
        <TouchableOpacity
          onPress={() => {
            navigation.goBack();
          }}
          style={{ marginRight: 12 }}
        >
          <BackArrow color={colors.black} />
        </TouchableOpacity>
        <Text bold mukta fontType="head2" style={styles.text}>
          {params && params.account_type === "vpa"
            ? t(`${PATH}/enterUPI`)
            : t(`${PATH}/enterBankAcc`)}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  beLikeRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  headerContainer: {
    padding: 10,
    paddingVertical: 14,
    backgroundColor: colors.white,
  },
});

export default WithdrawMoneyHeader;
